import React from "react";

export default function QuestionBlock({ title, subtitle, options, selected, onSelect, name }) {
  return (
    <div className="card-uniform">

      <h5 className="mb-1">{title}</h5>
      {subtitle && <small className="text-muted">{subtitle}</small>}

      <div className="mt-3">
        {options.map((op, index) => (
          <div key={index} className="form-check mb-2">
            <input
              className="form-check-input"
              type="radio"
              name={name}      
              checked={selected === op}
              onChange={() => onSelect(op)}
            />
            <label className="form-check-label">
              {op}
            </label>
          </div>
        ))}
      </div>

    </div>
  );
}

